module.exports = __webpack_public_path__ + "img/gq.2fdb4cb9.svg";